import React from "react";

export default function Blockquote({ attributes, style, children }) {
  return (
    <blockquote
      style={{
        paddingLeft: 10,
        fontSize: 22,
        color: "#04346e",
        fontStyle: "italic",
        margin: "35px 0px 35px 60px !important",
        ...style,
      }}
      {...attributes}
    >
      {children}
    </blockquote>
  );
}
